<!--  S E L E C T I O N   C R I T E R I A  -->

<app-choose-brand [displayBrandDialog] = "openBrandSelectionDialog" (chooseBrandEvent)="chooseBrand($event)"></app-choose-brand>
<!-- 
<app-query-builder [displayQueryBuilderDialog] = "openQueryBuilderDialog" (queryBuilderEvent)="queryBuilderEvent($event)"></app-query-builder> 
-->

<div class="grid">
    <div class="col-7">
        <p-message severity="info" text="{{titleMessage}}"></p-message>
    </div>
   <div class="col-1">
       <button pButton type="button" label="Brand" icon="pi pi-sitemap" iconPos="left" (click)="onChooseBrandClick($event)"  
            class="p-button-raised p-button-rounded">
        </button>
   </div>  
<!-- 
   <div class="col-1">
        <button pButton type="button" label="Query" icon="pi pi-sitemap" iconPos="left" (click)="onQueryBuilderClick($event)"  
            class="p-button-raised p-button-rounded">
        </button>
    </div>  
 -->
</div> 

<div class="grid">

    <div class="col-7">

        <div class="div-criteria-two">

            <div class="grid">

                <div class="col-5">
                    <div class="field grid">
                        <div class="col-1"></div>
                        <label for="extAccountId" class="col-fixed labell" style="width: 14em">External Account Id: </label>
                        <div class="col-3">
                            <input pInputText id="extAccountId" [(ngModel)]="extAccountId" style="width: 10em"/>
                        </div>
                    </div>
                </div>
                @if(isAccountStatusShown) {
                    <div class="col-5">
                        <div class="field grid">
                            <div class="col-1"></div>
                            <label for="accountStatus" class="col-fixed label" style="width: 10em">Account Status: </label>
                            <div class="col-4">
                                <!-- <label style="color:black">{{accountStatus}}</label> -->
                                <input pInputText id="accountStatus" [(ngModel)]="accountStatus" style="width: 15em" readonly/>
                                <!-- <p-message [severity]="getAccountStatus()" text="{{accountStatus}}"></p-message> -->
                            </div>
                        </div>         
                    </div>
                }
                <div class="col-2">
                    <p-button type="button" label="Find Account" styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" (click)="onSearchClick($event)"></p-button>
                </div> 
                    
            </div>

        </div>

    </div>

    @if(isDeregQueueShown) {

        <div class="col-3">

            <p-table [value]="deregQueueRec" tableStyleClass="prime-table">
                <ng-template pTemplate="header">
                    <tr>
                        <th [ngStyle]="{'background-color': 'Gainsboro'}">Deregistration Queue Placement</th>
                        <th [ngStyle]="{'background-color': 'Gainsboro'}">Grace Period Expiration</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rec>
                    <tr>
                        <td>{{ rec.placementDt }}</td>
                        <td>{{ rec.gracePeriodExpireDt }}</td>
                    </tr>
                </ng-template>
            </p-table>        

        </div>

    }

</div>


<div class="grid pt-5" [hidden]="customerpassHidden">

    <!--  C U S T O M E R P A S S  -->

    <div class="grid">
    
        <div class="col-10" *ngIf="isAccountStatusShown">

            <p-table #dtt [columns]="customerpassCols" [value]="customerpass" selectionMode="single" 
                class="wal-table"
                tableStyleClass="prime-table" [showCurrentPageReport]="false" [paginator]="false" >
                <ng-template pTemplate="caption">
                  Customer Pass
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
						@for (col of columns; track col.field) {
							<th [pSortableColumn]="col.field"
								[style.display]="col.display"
								[style.width]="col.width">
								{{ col.header }}
								<p-sortIcon [field]="col.field"></p-sortIcon>
							</th>
						}
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr [pSelectableRow]="rowData">
                        @for (col of columns; track col.field) {
                            <td [style.width]="col.width" [style.display]="col.display">
                                {{ rowData[col.field] }}
                            </td>
                        }
                    </tr>
                </ng-template>
            </p-table> 

        </div>

        <div class="col-1">
            <button pButton type="button"  icon="pi pi-angle-double-left"  (click)="onPriorCustomerpass($event)"  
                class="p-button-raised p-button-rounded"  [disabled]="priorDisabled"></button>
            <button pButton type="button"  icon="pi pi-angle-double-right"  (click)="onNextCustomerpass($event)"  
                class="p-button-raised p-button-rounded" [disabled]="nextDisabled"></button>
        </div>

    </div>  

</div>  

<div class="grid pt-5" *ngIf="isAccountStatusShown">

        <p-tabs class="wal-tabs" [(value)]="tabIndex">

          <p-tablist>

            <p-tab [value]="'Pass Registers'">
              <span class="tab-label">
                <span class="ml-2">Pass Registers</span>
              </span>
            </p-tab>

            <p-tab [value]="'Variable Values'">
              <span class="tab-label">
                <span class="ml-2">Variable Values</span>
              </span>
            </p-tab>

            <p-tab [value]="'Notification Messages'">
              <span class="tab-label">
                <span class="ml-2">Notification Messages</span>
              </span>
            </p-tab>

            <p-tab [value]="'Account Events Log'">
              <span class="tab-label">
                <span class="ml-2">Account Events Log</span>
              </span>
            </p-tab>

            <p-tab [value]="'Clickthroughs Log'">
              <span class="tab-label">
                <span class="ml-2">Clickthroughs Log</span>
              </span>
            </p-tab>

          </p-tablist>  

          <p-tabpanels>

            <p-tabpanel [value]="'Pass Registers'" [hidden]="customerpassHidden">

                <div class="col-10">

                    <p-table #dtt [columns]="passregistersCols" [value]="passregisters" selectionMode="single" 
                        tableStyleClass="prime-table" [showCurrentPageReport]="true"  class="wal-table"
                        sortMode="multiple" [paginator]="true" [rows]="15">
                        <ng-template pTemplate="caption">
                            Pass Registers
                        </ng-template>
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                @for (col of columns; track col.field) {
                                    <th [pSortableColumn]="col.field"
                                        [style.display]="col.display"
                                        [style.width]="col.width">
                                        {{ col.header }}
                                        <p-sortIcon [field]="col.field"></p-sortIcon>
                                    </th>
                                }
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr [pSelectableRow]="rowData">
                                @for (col of columns; track col.field) {
                                    <td [style.width]="col.width" [style.display]="col.display">
                                        {{ rowData[col.field] }}
                                    </td>
                                }
                            </tr>
                        </ng-template>
                    </p-table> 

                </div>

            </p-tabpanel>

            <p-tabpanel [value]="'Variable Values'" [hidden]="customerpassHidden">

                <div class="ui-g-5">

                    <p-table #dtt [columns]="varValuesCols" [value]="varValues" selectionMode="single" 
                        tableStyleClass="prime-table" [showCurrentPageReport]="true" class="wal-table"
                        sortMode="multiple" [paginator]="true" [rows]="15">
                        <ng-template pTemplate="caption">
                        Variable Values
                        </ng-template>
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                @for (col of columns; track col.field) {
                                    <th [pSortableColumn]="col.field"
                                        [style.display]="col.display"
                                        [style.width]="col.width">
                                        {{ col.header }}
                                        <p-sortIcon [field]="col.field"></p-sortIcon>
                                    </th>
                                }
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr [pSelectableRow]="rowData">
                                @for (col of columns; track col.field) {
                                    <td [style.width]="col.width" [style.display]="col.display">
                                        {{ rowData[col.field] }}
                                    </td>
                                }
                            </tr>
                        </ng-template>
                    </p-table> 

                </div>

            </p-tabpanel>

            <p-tabpanel [value]="'Notification Messages'">

                <div class="col-10">

                    <p-table #dtt [columns]="messagesCols" [value]="messages" selectionMode="single" 
                        tableStyleClass="prime-table" [showCurrentPageReport]="true"  class="wal-table"
                        sortMode="multiple" [paginator]="true" [rows]="15">
                        <ng-template pTemplate="caption">
                            Notification Messages
                        </ng-template>
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                @for (col of columns; track col.field) {
                                    <th [pSortableColumn]="col.field"
                                        [style.display]="col.display"
                                        [style.width]="col.width">
                                        {{ col.header }}
                                        <p-sortIcon [field]="col.field"></p-sortIcon>
                                    </th>
                                }
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr [pSelectableRow]="rowData">
                                @for (col of columns; track col.field) {
                                    <td [style.width]="col.width" [style.display]="col.display">
                                        {{ rowData[col.field] }}
                                    </td>
                                }
                            </tr>
                        </ng-template>
                    </p-table> 

                </div>

            </p-tabpanel>

            <p-tabpanel [value]="'Account Events Log'">

                <div class="col-10">

                    <p-table #dtt [columns]="accountEventLogCols" [value]="accountEventLog" selectionMode="single" 
                            class="wal-table"
                            tableStyleClass="prime-table" [showCurrentPageReport]="false" [paginator]="true" [rows]="2" >
                        <ng-template pTemplate="caption">
                            Account Events Log
                        </ng-template>
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                @for (col of columns; track col.field) {
                                    <th [pSortableColumn]="col.field"
                                        [style.display]="col.display"
                                        [style.width]="col.width">
                                        {{ col.header }}
                                        <p-sortIcon [field]="col.field"></p-sortIcon>
                                    </th>
                                }
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr [pSelectableRow]="rowData">
                                @for (col of columns; track col.field) {
                                    <td [style.width]="col.width" [style.display]="col.display">
                                        {{ rowData[col.field] }}
                                    </td>
                                }
                            </tr>
                        </ng-template>
                    </p-table> 

                </div>

            </p-tabpanel>

            <p-tabpanel [value]="'Clickthroughs Log'" [hidden]="isClickthroughHidden">

                <div class="col-12">

                    <p-table #dtt [columns]="clickthrouthLogCols" [value]="clickthrouthLog" selectionMode="single" 
                            tableStyleClass="prime-table" [showCurrentPageReport]="false" 
                            [paginator]="true" [rows]="15"  class="wal-table">
                        <ng-template pTemplate="caption">
                            Clickthroughs Log
                        </ng-template>
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                @for (col of columns; track col.field) {
                                    <th [pSortableColumn]="col.field"
                                        [style.display]="col.display"
                                        [style.width]="col.width">
                                        {{ col.header }}
                                        <p-sortIcon [field]="col.field"></p-sortIcon>
                                    </th>
                                }
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr [pSelectableRow]="rowData">
                                @for (col of columns; track col.field) {
                                    <td [style.width]="col.width" [style.display]="col.display">
                                        {{ rowData[col.field] }}
                                    </td>
                                }
                            </tr>
                        </ng-template>
                    </p-table> 

                </div>

            </p-tabpanel>

          </p-tabpanels>        

        </p-tabs>
	  

    
</div>
